<div *ngIf="!this.vouchers.data.length" style="background-color: #F5F7F8; height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
    <div style="text-align: center; padding: 10px;">
        <img style="z-index: 20; width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
        <h2 style="width: 100%; height: 22px; position: absolute; top: 20px; left: 0px; margin: auto; text-align: center;">Ваучери</h2>
        <p style="font-size: 16px; font-weight: bold; margin-top: 7px;">Нямаш налични ваучери</p>
        <!-- <p style="margin-top: 7px; color: #ADAFBB;">Покани трима приятели за да получиш ваучер на стойност 5 лв. Покани фирма и получи ваучер на стойност 20 лв!</p> -->
        <!-- <button (click)="this.inviteAndEarn()" type="button" class="btn btn-primary" style="width: 60%; margin: auto;">Покани и спечели</button> -->
    </div>
  </div>

  <div *ngIf="this.vouchers.data.length" style="padding-top: 10px; height: 100vh; width: 100vw; overflow-y: scroll; background-color: #F5F7F8;">
    <div  style="height: 78vh; width: 100vw; overflow-y: scroll; background-color: #F5F7F8;" >
        <div  style="height: 50px">
            <img style="z-index: 20; width: 22px; height: 22px; position: relative; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
            <h2 style="width: 100%; height: 22px; position: relative;  margin: auto; text-align: center;">{{ 'Ваучери' }}</h2>
            <img style="float: right;  width: 22px; height: 22px; position: absolute; top: 40px; right: 20px;" (click)="this.openInfo(voucherInfo)" src="/assets/images/vouchers/information.svg">
        </div>
        <div *ngFor="let voucher of this.vouchers.data" class="row" style="background-color: white; padding: 10px; border-radius: 10px; width: 90%; margin: auto; margin-top: 30px;" >
            <div class="col-3">
                <img style=" width: 50px; height: 50px; position: relative; top: 0px;"  src="/assets/images/vouchers/voucher.svg">
            </div>
            <div class="col-9">
                <p style="font-weight: 700; margin-bottom: 5px; margin-top: 5px; font-size: 15px;">
                  <app-price
                    class="voucher-card__amount"
                    [amount]="getVoucherAmountBase(voucher)"
                    layout="inline"
                  ></app-price>
                </p>
                <p style="color: #ADAFBB; font-size: 12px; margin-bottom: 5px;"> {{ this.fixVoucherDate(voucher.created_at) }}</p>

            </div>
        </div>
    </div>
  </div>

  <ng-template #voucherInfo let-modal>
    <div style="text-align: center;">
        <img src="/assets/images/vouchers/voucher.svg" alt="" style="height: 120px; width: 140px; margin-top: 30px; margin-bottom: 20px;"> <br>
        <p style="font-weight: bold; margin-top: 7px; font-size: 15px;">Използване на ваучери</p>
    </div>
    <ul class="row" style="margin: auto; margin-top: 25px; margin-bottom: 15px; width: 90%; text-align: justify;">
        <li style="text-align: justify; margin-bottom: 7px;">Само един ваучер може да бъде ползван при една поръчка</li>
        <li style="text-align: justify; margin-bottom: 7px;">Ваучерите могат да се ползват еднократно</li>
        <li style="text-align: justify; margin-bottom: 7px;">Ваучерите са валидни до посочената дата</li>
    </ul>
  </ng-template>
